const initialState =
{
	curentTab: 'list',
	topic_list: [],
	view_topic: null,
	scrollPerc: 0,
	fileType: '',
	fileData: null,
	page:1,
};

const contentshare = (state = initialState, action) => {
	switch (action.type) {
		case 'TOPIC_LIST':
			{
				return { ...state, curentTab: 'list', topic_list: [...action.data] };
			}

		case 'TOPIC_VIEW':
			{
				return { ...state, curentTab: 'list', view_topic: action.data ? { ...action.data } : null };
			}
		case 'TOPIC_SCROLL':
			{
				return { ...state, scrollPerc: action.percentage };
			}
		case 'VIEW_UPLOAD_FILE':
			{
				return { ...state, currentTab: 'list', fileType: action.fileType, fileData: action.fileData, view_topic: action.view_topic, topic_list: action.topic_list };
			}
		case 'CLEAR_UPLOAD_FILE':
			{
				return { ...state, currentTab: 'list', fileType: '', fileData: null };
			}
		case 'PAGECHANGE':
			{
				return { ...state, page: action.page};
			}
		default:
			return state;
	}
};


export default contentshare;
